import DeleteButton from '@src/main/ui/components/common/Dashboard/common/buttons/DeleteButton/DeleteButton';
import EditButton from '@src/main/ui/components/common/Dashboard/common/buttons/EditButton/EditButton';
import FavoriteButton from '@src/main/ui/components/common/Dashboard/common/buttons/FavoriteButton/FavoriteButton';
import ShowMoreButton from '@src/main/ui/components/common/Dashboard/common/buttons/ShowMoreButton/ShowMoreButton';
import { FC } from 'react';
import styles from './DashboardCardResumeButtons.module.scss';

interface DashboardCardResumeButtonsProps {
  onClickFavorites: () => void;
  onClickShowMoreInfo: () => void;
  onClickEdit: () => void;
  onClickDelete: () => void;
  isFavorite: boolean;
  actions: {
    edit?: boolean;
    delete?: boolean;
    favorite?: boolean;
    info?: boolean;
  };
}

const DashboardCardResumeButtons: FC<DashboardCardResumeButtonsProps> = ({
  onClickEdit,
  onClickDelete,
  onClickFavorites,
  onClickShowMoreInfo,
  isFavorite,
  actions,
}) => (
  <div className={styles.dashboardCardResumeButtons}>
    {actions.edit && <EditButton onClickEdit={onClickEdit} />}
    {actions.delete && <DeleteButton onClickDelete={onClickDelete} />}
    {actions.favorite && (
      <FavoriteButton onClickFavorites={onClickFavorites} isFavorite={isFavorite} />
    )}
    {actions.info && <ShowMoreButton onClickShowMoreInfo={onClickShowMoreInfo} />}
  </div>
);

export default DashboardCardResumeButtons;
